<template>
	<div class="coensmCmss">
		<div class="promote">
			<van-nav-bar :title="$t('_homeTile_tab._Girodasorte')" left-arrow fixed placeholder :right-text="$t('promote._Histórico')"
				@click-right="openUrl('records')" @click-left="onClickLeft" />
			<div class="_event-lucky-wheel_1yc53_17">
				<div class="lucky-wheel-item turntable">
					<div class="_base-info-wrap_wkq00_17">
						<div class="_base-info_wkq00_17">
							<div class="info">
								<div><span class="label"> {{$t('promote._Pontosdesorteatuais')}}</span><span v-if="formDate.lucky"
										class="value">{{formDate.lucky.total}}</span></div>
							</div>
							<p class="btn"  @click="isDetalhes=true">{{$t('menGMen._Detalhes')}}</p>
						</div>
						<div class="bet-tips">
							
							{{$t('promote._Vocaindaprecisaapostar')}} <span>1</span> {{$t('promote._paraobter')}} <span>1</span> {{$t('promote._Pontosdesorte')}}</div>
					</div>
					<div v-for="(item,index) in letUrl" v-if="type-1==index"
						class="_turntable_1i0ek_17 _turntable-style10_1i0ek_89">
						<div class="lobby-image lobby-image lobby-image--use-bg wheel" id="wheel"
							:style="letUrl[type-1].style+'transform:'+`rotate(${transformtargetAngle}deg)`">
							<!---->
							<!-- formDate.turntable.silver -->
							<!-- letUrl -->
							<div class="_whell-item_1i0ek_89" v-for="(itm,inx) in formDate.turntable[item.type].list"
								:style="{
								transform: `rotate(${inx?inx*36:0}deg)`
							}">
								<div class="_center_1i0ek_110">
									<p>{{itm}}</p>
								</div><img class="lobby-image lobby-image" :src="letUrl[type-1].url" alt=".">
							</div>
						</div>
						<div class="lobby-image lobby-image lobby-image--use-bg wheel-pointer"
							data-id="4b4afa5b-24b7-4c26-8971-da40c826ab62" :style="letUrl[type-1].style2">
							<!----><img class="lobby-image lobby-image" style="opacity: 0;"
								:src="require('./../../assets/zpimg/zphd_xzg_s2.png')"
								alt=".">
						</div>
						<div class="lobby-image lobby-image lobby-image--use-bg whell-btn"
							:style="letUrl[type-1].style1" @click="startTurntable">
							<div class="draw">{{$t('promote._RODAR')}}</div>
						</div>
					</div>
					
					<div class="_turntable-tabs_1yc53_62" v-if="formDate.turntable">
						<div class="_silver_1yc53_106" :class="type==1?'_active_1yc53_99':''" @click="funMensg(1)">
							<p>{{$t('promote._RodaPrata')}}</p><span>{{$t('promote._Pontosdesorte')}}{{formDate.turntable.silver.use_lucky}}</span>
						</div>
						<div class="_gold_1yc53_109" :class="type==2?'_active_1yc53_99':''"  @click="funMensg(2)">
							<p>{{$t('promote._RodaOuro')}}</p><span>{{$t('promote._Pontosdesorte')}}{{formDate.turntable.gold.use_lucky}}</span>
						</div>
						<div class="_diamond_1yc53_112" :class="type==3?'_active_1yc53_99':''"  @click="funMensg(3)">
							<p>{{$t('promote._RodaDiamante')}}</p><span>{{$t('promote._Pontosdesorte')}}{{formDate.turntable.diamond.use_lucky}}</span>
						</div>
					</div>
				</div>
				<div class="comense">
					<van-tabs v-model="activeName" @click="routerFun" class="h" :lineWidth="(activeLength*6+'px')"
						animated line-height='1px'   background="var(--theme-main-bg-color)"
						:ellipsis="false" title-active-color="var(--theme-primary-color)"
						title-inactive-color="var(--theme-text-color-darken)" color="var(--theme-primary-color)">
						<van-tab title-style="font-size: 0.22rem;" v-for="(item,index) in tabList" :title="item.name"
							:name='index' :key="index">
							<div class="comntebts">
								<div style="height: 100%;overflow: hidden;">
									<div class="record-item" v-for="(item,index) in onloy_recordLIst">
										<div class="record-info">
											<img v-if="type==1" class="lobby-image lobby-image lobby-image--skeleton" :src="require('./../../assets/zpimg/zphd_icon_silver.png')">
											<img  v-if="type==2"  class="lobby-image lobby-image lobby-image--skeleton" :src="require('./../../assets/zpimg/zphd_icon_gold.png')">
											<img  v-if="type==3"  class="lobby-image lobby-image lobby-image--skeleton" :src="require('./../../assets/zpimg/zphd_icon_diamond.png')">
											<div class="record-desc">
												<p class="time">{{item.time}}</p>
												<p>{{item.user_name}}</p>
											</div>
										</div><span class="amount">{{item.amount}}</span>
									</div>
								</div>
								<van-empty
									v-if="!onloy_recordLIst.length"
								    image-size="2.1rem"
								    class="custom-image"
								    :image="img_none_sj"
								    :description="$t('description')"
								/>
								
							</div>
						</van-tab>
					</van-tabs>
				</div>

				<div class="public-introduction _introduction_109ll_17">
					<div class="introduction-inner">
						<div v-html="formDate.desc"></div>
					</div>
				</div>
			</div>
		</div>
		<MyToast :isShow="isMyToast"
		@cancel="isMyToast=false"
		:model="{
			title:$t('promote._Lembreteimportante'),
			message:message,
			type:'fail',//success fail
		}"></MyToast>
		<Detalhes :isShow="isDetalhes"
			:model="{
				title:'Detalhes',
				...formDate.lucky
			}"
			@cancel="isDetalhes=false"
		>
			
		</Detalhes>
		<event></event>
	</div>
</template>

<script>
	// 概率配置（百分比模式）
	const probabilityConfig = {
			10:"10",
			9:"10",
			8:"10",
			7:"10",
			6:"10",
			5:"10",
			4:"10",
			3:"10",
			2:"10",
			1:"10"
	};

	// 角度映射表（自动生成）
	let angleMap = [];
	let currentAngle = 360;
	Object.entries(probabilityConfig).forEach(([name, percent]) => {
		const start = currentAngle;
		const end = currentAngle - 36;
		angleMap.push({
			name,
			start,
			end
		});
		currentAngle = end;
	});

	// 旋转控制
	let targetAngle = 0;
	let isRotating = false;

	import {
		luckyTurntable,
		startTurntable
	} from "@/apis/modules/detail.js"
	import {
		mapState
	} from 'vuex';
	// 
	import MyToast from "@/components/MyToast/index.vue"
	import Detalhes from "@/components/MyToast/Detalhes.vue"
	import event from "@/components/event.vue"
	
	
	export default {
		computed: {
			...mapState(['vuex_token_head','popList', 'tabNav', 'banner', 'sidebarsList', 'marquee'])
		},
		components:{
				MyToast,
				Detalhes,
				event
		},
		data() {
			return {
				message:false,
				isMyToast:false,
				activeName: 0,
				isDetalhes:false,
				activeLength: 24,
				tabList: [{
						name: 'Notificação de Prêmio'
					},
					{
						name: 'Meus Registros'
					},
				],
				tabIntdex: 'none',
				type: 1,
				onloy_recordLIst:[],
				formDate: {

				},
				transformtargetAngle:0,
				is_my: 0,
				vencedora:{
					
				},
				letUrl: [{
						type: 'silver',
						url: require('./../../assets/zpimg/img_zphdjp_s1.png'),
						style: 'background-image: url('+require('./../../assets/zpimg/zphd_bj_s1.png')+'); transform: rotate(0deg);',
						style1: 'background-image: url('+require('./../../assets/zpimg/zphd_ljcj_s1.png')+');',
						style2: 'background-image: url('+require('./../../assets/zpimg/zphd_zz_s1.png')+');',

					},
					{
						type: 'gold',
						url: require('./../../assets/zpimg/img_zphdjp_s2.png'),
						style: 'background-image: url('+require('./../../assets/zpimg/zphd_bj_s2.png')+'); transform: rotate(0deg);',
						style1: 'background-image: url('+require('./../../assets/zpimg/zphd_ljcj_s2.png')+');',
						style2: 'background-image: url('+require('./../../assets/zpimg/zphd_zz_s2.png')+');',

					},
					{
						type: 'diamond',
						url: require('./../../assets/zpimg/img_zphdjp_s3.png'),
						style: 'background-image: url('+require('./../../assets/zpimg/zphd_bj_s3.png')+'); transform: rotate(0deg);',
						style1: 'background-image: url('+require('./../../assets/zpimg/zphd_ljcj_s3.png')+');',
						style2: 'background-image: url('+require('./../../assets/zpimg/zphd_zz_s3.png')+');'
					}
				]
			}
		},
		created() {
			this.getNotification();
			// this.startTurntable();
		},
		methods: {
			funMensg(type){
				if(!isRotating){
					this.transformtargetAngle=0;
					this.type=type;
					isRotating=false;
					targetAngle=0;
					this.routerFun(this.is_my);
				}
			},
			checkLogin(){
				if(!this.vuex_token_head){
					let rememberPassword = window.localStorage.getItem('rememberPassword');
					if(rememberPassword && rememberPassword.length){
						this.$store.commit('isRecord')
						this.$store.commit('publicFun',['isRecordType',1])
					}else{
						this.$store.commit('isRecord')
						this.$store.commit('publicFun',['isRecordType',0])	
					}
					return false;
				}
				return true;
			},
			startTurntable() {
				if(!this.checkLogin())return;
				if (isRotating) return;
				this.$store.commit('publicFun',['emnegConme',true]);
				// return false;
				startTurntable({
					type: this.type
				}).then(({
					code,
					data,
					msg
				}) => { //404
					if(code==1){
						this.isMyToast=true;
						this.$store.commit('publicFun',['emnegConme',false]);
						this.message=msg;
						return false;
					}
					let {money,lucky} = data;
					data.index=money;
					this.vencedora=data;
					this.startLottery();
				})
			},
			routerFun(e){//
				this.is_my=e;
				this.onloy_recordLIst=[];
				this.getNotification();
			},
			getNotification(onloy_record) {
				luckyTurntable({
					type: this.type,
					is_my: this.is_my,
					onloy_record:onloy_record,
				}).then(({
					code,
					data,
					msg
				}) => { //404
					let {
						marquee
					} = data;
					this.formDate = data;
					this.onloy_recordLIst=this.is_my ? data.my_receive : data.receive;
				})
			},
			startLottery() {
				if (isRotating) return;
				const wheel = document.getElementById('wheel');
				isRotating = true;
				this.$store.commit('publicFun',['emnegConme',true]);
				// 生成随机结果
				const targetResult = angleMap[this.vencedora.index]; //中奖号码
				//getRandomResult();
				const baseRotation = 360 * 6; // 基础6圈
				// 计算最终角度（在结果区间内随机）
				console.log(targetResult,this.vencedora);
				if(targetAngle){
					targetAngle = targetAngle + baseRotation ;
				}else{
					targetAngle = targetAngle + baseRotation +targetResult.start;
				}
				// 执行旋转
				// wheel.style.transform = `rotate(${targetAngle}deg)`;
				this.transformtargetAngle=targetAngle
				// 结果处理
				wheel.addEventListener('transitionend', () => {
					isRotating = false;
					this.$store.commit('publicFun',['emnegConme',false]);
				}, {
					once: true
				});
			},
			onClickLeft() {
				this.$router.go(-1);
			}
		}
	}
</script>

<style>
	.comntebts{
		padding: .2rem;
	}
	.record-item {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    border-radius: .1rem;
	    padding: .2rem;
	    margin-right: .2rem
	}
	.record-item:nth-child(odd){
		background-color: var(--theme-bg-color);
	}
	.record-item .record-info {
	    display: flex;
	    align-items: center;
	    color: var(--theme-btm-def-color);
	    font-size: .2rem;
	    text-align: left
	}
	.record-item .record-info img {
	    width: .44rem;
	    height: .44rem;
	    margin-right: .2rem
	}
	.record-item .record-info .record-desc {
	    display: flex;
	    align-items: center;
	    margin-right: .1rem
	}
	.record-item .record-info .record-desc .time {
	    width: 1.6rem
	}
	.record-item .amount {
	    font-size: .22rem;
	    color: var(--theme-secondary-color-finance);
	}
	.promote .comense .h .van-tab__pane {
		height: 5rem;
	}
	.promote .comense .h  .van-tab__pane-wrapper{
		padding-bottom: .2rem;
	}
	.comense {
		background-color: var(--theme-main-bg-color);
		border-radius: .14rem;
		overflow: hidden;
		margin-bottom: .2rem;
	}

	/* --theme-alt-neutral-2 */
	.coensmCmss .van-nav-bar__right,
	.coensmCmss .van-nav-bar__text {
		color: var(--theme-primary-color) !important;
	}

	._event-lucky-wheel_1yc53_17 {
		padding: .2rem
	}

	._introduction_109ll_17 .introduction-inner {
		padding: .2rem;
		overflow-y: auto;
		color: var(--theme-text-color);
		font-size: .26rem;
		line-height: .42rem;
		white-space: pre-wrap;
		word-break: break-word;
		background-color: var(--theme-main-bg-color);
		border-radius: .1rem;
		box-shadow: 0 .03rem .09rem rgba(0, 0, 0, .06)
	}

	._introduction_109ll_17 .introduction-inner .text-darken {
		font-weight: 700
	}


	._event-lucky-wheel_1yc53_17 .lucky-wheel-item {
		border-radius: .14rem;
		background-color: var(--theme-main-bg-color);
		margin-bottom: .2rem
	}

	._event-lucky-wheel_1yc53_17 .turntable {
		padding: 0 .2rem .2rem
	}

	._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs {
		flex: 1;
		background-color: var(--theme-main-bg-color);
		border-radius: .14rem;
		box-shadow: 0 .03rem .09rem 0 var(--theme-bg-shadow)
	}

	._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs .ui-tabs__wrap {
		height: .8rem;
		padding: 0 .2rem;
		border-bottom: var(--lobby__px) solid var(--theme-color-line)
	}

	._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs .ui-tabs__wrap .ui-tabs__nav {
		gap: .6rem;
		overflow-x: scroll;
		overflow-y: hidden;
		max-width: 100%
	}

	._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs .ui-tabs__wrap .ui-tab {
		flex: none;
		font-size: .26rem
	}

	._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs .ui-tabs__content {
		height: calc(100% - .8rem);
		padding: .2rem 0 .2rem .2rem
	}

	._event-lucky-wheel_1yc53_17 .public-introduction {
		padding: 0;
		margin-top: 0
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: .05rem;
		background-color: var(--theme-main-bg-color);
		border-radius: .05rem;
		box-shadow: 0 .02rem .04rem 0 var(--skin__web_left_bg_shadow)
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 {
		position: relative;
		width: 100%;
		height: .8rem;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		opacity: 1
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 ._active-icon_hp4jz_38 {
		display: block;
		width: .86rem;
		height: .78rem;
		background-size: 100% 100%
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		width: 100%;
		height: 100%;
		border: thin solid var(--skin__primary);
		border-radius: .05rem;
		overflow: hidden
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 i[class~=bg] {
		color: var(--skin__filter_active) !important
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 .bg {
		transform: rotate(45deg) scale(1.4);
		position: relative;
		left: .15rem;
		top: .15rem;
		background-color: var(--skin__filter_active)
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 .gou {
		z-index: 1
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20:not(._is-checked_hp4jz_68) ._checked-status_hp4jz_44 {
		display: none
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20._is-checked_hp4jz_68 ._checked-status_hp4jz_44 {
		display: block
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 ._active-icon_hp4jz_38 {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 0
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: .05rem;
		background-color: var(--theme-main-bg-color);
		border-radius: .05rem;
		box-shadow: 0 .02rem .04rem 0 var(--skin__web_left_bg_shadow)
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 {
		position: relative;
		width: 100%;
		height: .8rem;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		opacity: 1
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 ._active-icon_hp4jz_38 {
		display: block;
		width: .86rem;
		height: .78rem;
		background-size: 100% 100%
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		width: 100%;
		height: 100%;
		border: thin solid var(--skin__primary);
		border-radius: .05rem;
		overflow: hidden
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 i[class~=bg] {
		color: var(--skin__filter_active) !important
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 .bg {
		transform: rotate(45deg) scale(1.4);
		position: relative;
		left: .15rem;
		top: .15rem;
		background-color: var(--skin__filter_active)
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 .gou {
		z-index: 1
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20:not(._is-checked_hp4jz_68) ._checked-status_hp4jz_44 {
		display: none
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20._is-checked_hp4jz_68 ._checked-status_hp4jz_44 {
		display: block
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 ._active-icon_hp4jz_38 {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		right: 0
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: .05rem;
		background-color: var(--theme-main-bg-color);
		border-radius: .05rem;
		box-shadow: 0 .02rem .04rem 0 var(--skin__web_left_bg_shadow)
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 {
		position: relative;
		width: 100%;
		height: .8rem;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		opacity: 1
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 ._active-icon_hp4jz_38 {
		display: block;
		width: .86rem;
		height: .78rem;
		background-size: 100% 100%
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		width: 100%;
		height: 100%;
		border: thin solid var(--skin__primary);
		border-radius: .05rem;
		overflow: hidden
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 i[class~=bg] {
		color: var(--skin__filter_active) !important
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 .bg {
		transform: rotate(45deg) scale(1.4);
		position: relative;
		left: .15rem;
		top: .15rem;
		background-color: var(--skin__filter_active)
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 .gou {
		z-index: 1
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20:not(._is-checked_hp4jz_68) ._checked-status_hp4jz_44 {
		display: none
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20._is-checked_hp4jz_68 ._checked-status_hp4jz_44 {
		display: block
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 ._active-icon_hp4jz_38 {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		display: none
	}

	._bottom-nav-item_1yyzn_17 ._active-name_1yyzn_17 {
		margin-top: .1rem;
		font-size: .18rem;
		text-align: center;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis
	}

	._bottom-nav-item_1yyzn_17:not(._is-checked_1yyzn_26) ._active-name_1yyzn_17 {
		color: var(--theme-text-color)
	}

	._bottom-nav-item_1yyzn_17._is-checked_1yyzn_26 ._active-name_1yyzn_17 {
		color: var(--skin__primary)
	}

	._bottom-nav-item_1yyzn_17 {
		opacity: 1
	}

	._activities-bar-item_ycxm1_17 {
		width: 1.88rem
	}

	._events-bar_19vjj_17 {
		display: flex;
		align-items: center;
		padding-bottom: 0;
		justify-content: center;
		width: 100%;
		padding-right: .2rem;
		padding-left: .2rem
	}

	._events-bar_19vjj_17 .ui-tabs {
		max-width: 100%
	}

	._events-bar_19vjj_17 .ui-tabs .ui-tabs__wrap .ui-tabs__nav {
		background-color: transparent
	}

	._events-bar_19vjj_17 .ui-tabs .ui-tabs__wrap {
		border-bottom: unset
	}

	._events-bar_19vjj_17 .ui-tabs__line,
	._events-bar_19vjj_17 .ui-tabs__content {
		display: none
	}

	._events-bar_19vjj_17 .ui-tabs__nav--line {
		padding-bottom: 0
	}

	._events-bar_19vjj_17 ._event-bar-item_19vjj_42 {
		padding: 0;
		margin-right: .2rem
	}

	._events-bar_19vjj_17>div {
		max-width: 100%
	}

	._events-bar_19vjj_17 ._swiper-container_19vjj_49 {
		height: .9rem
	}

	._events-bar_19vjj_17 ._scrollEvents_19vjj_52 {
		flex-shrink: 0;
		width: .4rem;
		height: .4rem;
		margin-bottom: .14rem;
		color: var(--skin__primary);
		font-size: .18rem;
		line-height: .4rem;
		text-align: center;
		background-color: var(--theme-main-bg-color);
		border: thin solid var(--theme-color-line);
		border-radius: 50%;
		cursor: pointer
	}

	._events-bar_19vjj_17 ._scrollEvents_19vjj_52:first-child {
		margin-right: .1rem
	}

	._events-bar_19vjj_17 ._scrollEvents_19vjj_52:last-child {
		margin-left: .1rem
	}

	._events-bar_19vjj_17 ._scrollEvents_19vjj_52._btnDisabled_19vjj_72 {
		color: var(--theme-text-color);
		cursor: no-drop
	}

	._visible-hidden_19vjj_77 {
		visibility: hidden
	}

	._swiperSlideWidth_19vjj_81 {
		width: 1.88rem !important
	}

	._nav2Wraper_19vjj_85 {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%
	}

	._nav2Wraper_19vjj_85 li:first-child {
		margin-right: .25rem
	}

	._nav2Wraper_19vjj_85 .swiper-slide,
	._nav4Wrapper_19vjj_100 .swiper-slide {
		width: 1.88rem !important;
		margin-right: .2rem !important;
		transform: translate(-.3rem)
	}

	._navless4Wrapper_19vjj_106 .swiper-slide {
		width: 1.88rem !important
	}

	._header-sub-btn_17wo2_17 {
		position: absolute;
		right: 0;
		width: 1.3rem;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 .1rem;
		text-align: center;
		color: var(--skin__primary);
		font-size: .24rem;
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		vertical-align: middle;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical
	}

	._header-sub-btn_17wo2_17:lang(zh) {
		word-break: break-all
	}

	._header-sub-btn_17wo2_17:not(:lang(zh)) {
		word-break: break-word
	}

	._event-item-box_qhu5g_17 .lobby-scroll {
		z-index: initial
	}

	._event-item-box_qhu5g_17 .ui-placeholder__nested-loading {
		max-height: calc(var(--lobby__screen-height) - 1.8rem)
	}

	._event-item-header_qhu5g_24 ._event-header-center_qhu5g_24 {
		max-width: 4.3rem;
		word-break: break-all;
		text-align: center;
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		vertical-align: middle;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical
	}

	._event-item-header_qhu5g_24 ._event-header-center_qhu5g_24:not(:lang(zh)) {
		word-break: break-word
	}

	._customizeWrap_qhu5g_39 {
		min-height: 100%;
		overflow-y: scroll;
		display: flex;
		flex-flow: column
	}

	._placeholder-box_qhu5g_46 {
		min-height: 6rem
	}

	._bar_qhu5g_50._normal_qhu5g_50 {
		margin-bottom: .2rem
	}

	._bar_qhu5g_50._bottom-btn_qhu5g_53 {
		margin-bottom: 1.3rem
	}

	._bar_qhu5g_50._customize-bottom-btn_qhu5g_56 {
		margin-bottom: 1.8rem
	}

	._ranking-list-bottom-box_ov7eu_17 {
		display: flex;
		flex-direction: column;
		margin: .2rem;
		padding: .2rem;
		color: var(--theme-text-color);
		font-size: .22rem;
		background-color: var(--theme-main-bg-color);
		border-radius: .1rem;
		box-shadow: 0 .03rem .09rem rgba(0, 0, 0, .06)
	}

	._ranking-list-bottom-box_ov7eu_17 .ui-placeholder--nested .ui-placeholder__nested-loading {
		height: calc(.5 * var(--lobby__screen-height) - 1.2rem)
	}

	._ranking-list-bottom-box_ov7eu_17>h1 {
		color: var(--theme-text-color);
		font-size: .24rem;
		text-align: center;
		font-weight: 400;
		margin-bottom: .2rem
	}

	._ranking-list-bottom-box_ov7eu_17 ._ranking-box_ov7eu_38 {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%
	}

	._ranking-list-bottom-box_ov7eu_17 ._ranking-info_ov7eu_44 {
		margin-right: .1rem
	}

	._ranking-list-bottom-box_ov7eu_17 ._ranking-list-table_ov7eu_47 {
		margin-top: .2rem
	}

	._ranking-list-bottom-box_ov7eu_17 ._refresh-btn_ov7eu_50 {
		text-align: center
	}

	._ranking-list-bottom-box_ov7eu_17 ._refresh-btn_ov7eu_50 .countdown {
		justify-content: center
	}

	._ranking-list-bottom-box_ov7eu_17 ._refresh-btn_ov7eu_50 .countdown span {
		color: #fff
	}

	._ranking-list-bottom-box_ov7eu_17 ._refresh-btn_ov7eu_50 .ui-button__text {
		width: 1.2rem;
		line-height: .28rem
	}

	._ranking-list-bottom-box_ov7eu_17 ._ranking-today_ov7eu_63 {
		margin: 0 .1rem;
		color: var(--theme-text-color)
	}

	._ranking-list-bottom-box_ov7eu_17 ._ranking-today_ov7eu_63 .ranking-icon {
		width: .5rem;
		min-height: .3rem;
		position: relative;
		top: .1rem
	}

	._ranking-list-bottom-box_ov7eu_17 ._ranking-today_ov7eu_63 .ranking-icon:lang(zh) {
		margin-top: -.02rem
	}

	._ranking-list-bottom-box_ov7eu_17 ._today-bonus_ov7eu_76 {
		margin-left: .1rem;
		color: var(--theme-text-color)
	}

	._ranking-list-bottom-box_ov7eu_17 ._yellow_ov7eu_80 {
		color: var(--theme-primary-color)
	}

	._margin-top-fit_ov7eu_84 {
		margin-top: 0
	}

	._ranking-list-yesterday_1nhqp_17 {
		display: flex;
		flex-direction: column;
		color: var(--theme-text-color);
		font-size: .22rem;
		background-color: var(--theme-main-bg-color);
		border-radius: .1rem;
		box-shadow: 0 .03rem .09rem rgba(0, 0, 0, .06)
	}

	._ranking-list-yesterday_1nhqp_17 .ui-list {
		max-height: 6.26rem;
		overflow-y: auto
	}

	._ranking-list-top-box_1nhqp_31 {
		display: flex;
		justify-content: space-between
	}

	._ranking-list-top-box_1nhqp_31 ._top_1nhqp_35 {
		display: flex;
		align-items: center;
		height: .48rem
	}

	._ranking-list-top-box_1nhqp_31 p+p {
		margin-top: .12rem
	}

	._ranking-list-top-box_1nhqp_31 ._bottom_1nhqp_43 {
		line-height: 1
	}

	._ranking-list-top-box_1nhqp_31 ._detail_1nhqp_46 {
		margin-left: .1rem;
		color: var(--skin__primary);
		font-size: .22rem;
		cursor: pointer
	}

	._ranking-list-top-box_1nhqp_31 ._ranking-last_1nhqp_52 {
		margin-left: .1rem;
		color: var(--theme-text-color);
		line-height: 1
	}

	._ranking-list-top-box_1nhqp_31 ._ranking-last_1nhqp_52 .ranking-icon {
		width: .5rem;
		min-height: .3rem
	}

	._ranking-list-top-box_1nhqp_31 ._ranking-award_1nhqp_61 {
		margin-left: .1rem
	}

	._ranking-list-top-box_1nhqp_31 ._yellow_1nhqp_64 {
		color: var(--theme-primary-color)
	}

	._ranking-list-top-box_1nhqp_31 ._ranking-list-top-left_1nhqp_67 p {
		display: flex;
		align-items: center
	}

	._detailModal_1nhqp_72 .ui-dialog__header {
		font-size: .24rem;
		height: .74rem;
		color: var(--theme-text-color)
	}

	._ranking-list-top-container_orrvr_17 {
		position: sticky;
		top: 0;
		padding: .2rem;
		background-color: var(--skin__bg_1);
		z-index: 2
	}

	._ranking-list-top-box_orrvr_25 {
		display: flex;
		justify-content: space-between;
		height: 1.32rem;
		padding: .2rem;
		color: var(--theme-text-color);
		font-size: .22rem;
		background-color: var(--theme-main-bg-color);
		border-radius: .1rem;
		box-shadow: 0 .03rem .09rem rgba(0, 0, 0, .06)
	}

	._ranking-list-top-box_orrvr_25 ._top_orrvr_36 {
		display: flex;
		align-items: center;
		height: .48rem
	}

	._ranking-list-top-box_orrvr_25 p+p {
		margin-top: .12rem
	}

	._ranking-list-top-box_orrvr_25 ._detail_orrvr_44 {
		margin-left: .1rem;
		color: var(--skin__primary);
		font-size: .22rem;
		cursor: pointer
	}

	._ranking-list-top-box_orrvr_25 ._ranking-last_orrvr_50 {
		margin-left: .1rem;
		color: var(--theme-text-color)
	}

	._ranking-list-top-box_orrvr_25 ._ranking-last_orrvr_50 .ranking-icon {
		width: .5rem;
		min-height: .3rem
	}

	._ranking-list-top-box_orrvr_25 ._ranking-award_orrvr_58 {
		margin-left: .1rem;
		color: var(--theme-text-color)
	}

	._ranking-list-top-box_orrvr_25 ._yellow_orrvr_62 {
		color: var(--theme-primary-color)
	}

	._ranking-list-top-box_orrvr_25 ._ranking-list-top-left_orrvr_65 p {
		display: flex;
		align-items: center
	}

	._detailModal_orrvr_70 .ui-dialog__header {
		font-size: .3rem;
		height: .74rem;
		color: var(--theme-text-color)
	}

	._detailModal_orrvr_70 .ui-dialog__content {
		padding: 0 .2rem .2rem
	}

	._announcement_wo97m_17 {
		height: 5rem
	}

	._announcement_wo97m_17 .loading {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center
	}

	._announcement_wo97m_17 .record-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-radius: .1rem;
		padding: .2rem;
		margin-right: .2rem
	}

	._announcement_wo97m_17 .record-item:nth-child(odd) {
		background-color: var(--skin__bg_1)
	}

	._announcement_wo97m_17 .record-item:nth-child(2n) {
		background-color: var(--theme-main-bg-color)
	}

	._announcement_wo97m_17 .record-item .record-info {
		display: flex;
		align-items: center;
		color: var(--theme-text-color);
		font-size: .2rem;
		text-align: left
	}

	._announcement_wo97m_17 .record-item .record-info img {
		width: .44rem;
		height: .44rem;
		margin-right: .2rem
	}

	._announcement_wo97m_17 .record-item .record-info .record-desc {
		display: flex;
		align-items: center;
		margin-right: .1rem
	}

	._announcement_wo97m_17 .record-item .record-info .record-desc .time {
		width: 1.6rem
	}

	._announcement_wo97m_17 .record-item .amount {
		font-size: .22rem;
		color: var(--theme-primary-color)
	}

	._bet-detail-content_74syr_17 .item {
		margin: 0 .3rem .1rem 0;
		text-align: left
	}

	._bet-detail-content_74syr_17 .item label,
	._bet-detail-content_74syr_17 .item span {
		font-size: .22rem;
		line-height: .28rem;
		color: var(--theme-text-color)
	}

	._bet-detail-content_74syr_17 .item .value {
		margin-left: .1rem;
		color: var(--theme-text-color);
		font-weight: 700
	}

	._detail-list_1qqdz_17 {
		border-radius: .1rem
	}

	._detail-list_1qqdz_17 .list-item {
		display: flex
	}

	._detail-list_1qqdz_17 .list-item>div {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center
	}

	._detail-list_1qqdz_17 .list-item>div:first-child,
	._detail-list_1qqdz_17 .list-item>div:last-child {
		flex: none;
		width: 30%
	}

	._detail-list_1qqdz_17 .head {
		height: .8rem;
		background-color: var(--skin__bg_1);
		color: var(--theme-text-color);
		font-size: .24rem;
		border-radius: .1rem;
		border: var(--lobby__px) solid var(--theme-color-line);
		margin-right: .3rem
	}

	._detail-list_1qqdz_17 .body {
		height: .7rem;
		font-size: .2rem;
		color: var(--theme-text-color);
		border-radius: .1rem;
		margin-right: .3rem
	}

	._detail-list_1qqdz_17 .body div {
		line-height: .24rem
	}

	._detail-list_1qqdz_17 .body:nth-child(2n) {
		background-color: var(--skin__bg_1)
	}

	._detail-list_1qqdz_17 .body:nth-child(odd) {
		background-color: var(--theme-main-bg-color)
	}

	._detail-list_1qqdz_17 .body .reward-time {
		display: inline-block;
		width: 1.2rem;
		white-space: pre-wrap;
		line-height: .24rem
	}

	._detail-list_1qqdz_17 .body .lucky-text {
		color: var(--theme-primary-color)
	}

	._detail-list_1qqdz_17 .list-main {
		max-height: 3.5rem
	}

	._bet-detail-content_1qqdz_71 {
		margin-top: .3rem
	}

	._bet-detail-content_1qqdz_71 .item {
		margin: 0 .3rem .1rem 0;
		text-align: left
	}

	._bet-detail-content_1qqdz_71 .item label,
	._bet-detail-content_1qqdz_71 .item span {
		font-size: .2rem;
		line-height: .28rem;
		color: var(--theme-text-color)
	}

	._bet-detail-content_1qqdz_71 .item .value {
		margin-left: .1rem;
		color: var(--theme-text-color);
		font-weight: 700
	}

	._base-info-wrap_wkq00_17 {
		border-bottom: var(--lobby__px) solid var(--theme-color-line)
	}

	._base-info-wrap_wkq00_17 .bet-tips {
		margin-bottom: .2rem;
		font-size: .22rem;
		color: var(--theme-text-color)
	}

	._base-info-wrap_wkq00_17 .bet-tips>span:nth-child(1) {
		margin: 0 .05rem;
		color: var(--theme-text-color-darken)
	}

	._base-info-wrap_wkq00_17 .bet-tips>span:nth-child(2) {
		margin: 0 .05rem;
		color: var(--theme-primary-color)
	}

	._base-info-wrap_wkq00_17 ._base-info_wkq00_17 {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: .2rem;
		color: var(--theme-text-color);
		font-size: .24rem
	}

	._base-info-wrap_wkq00_17 ._base-info_wkq00_17 .info .label {
		margin-right: .1rem
	}

	._base-info-wrap_wkq00_17 ._base-info_wkq00_17 .info .value {
		color: var(--theme-primary-color)
	}

	._base-info-wrap_wkq00_17 ._base-info_wkq00_17 .btn {
		padding: .2rem 0;
		color: var(--theme-primary-color);
		font-size: .24rem;
		line-height: 1;
		cursor: pointer
	}

	html[data-gap-supported="0"] ._base-info-wrap_wkq00_17 ._base-info_wkq00_17>*+* {
		margin-left: .2rem
	}

	._bet-detail_wkq00_59 {
		width: 6.9rem
	}

	._bet-detail_wkq00_59 .ui-dialog__main {
		padding: .2rem 0 .3rem .3rem;
		min-height: max-content
	}

	._bet-detail_wkq00_59 .ui-dialog__main .ui-dialog__header {
		padding: 0;
		color: var(--theme-text-color)
	}

	._bet-detail_wkq00_59 .ui-dialog__main .ui-dialog__content {
		margin-top: .3rem;
		padding: 0
	}

	._my-record_fupzb_17 {
		height: 5rem
	}

	._my-record_fupzb_17 .loading {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center
	}

	._my-record_fupzb_17 .ui-empty {
		height: 100%
	}

	._my-record_fupzb_17 .record-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-radius: .1rem;
		padding: .2rem
	}

	._my-record_fupzb_17 .record-item:nth-child(odd) {
		background-color: var(--skin__bg_1)
	}

	._my-record_fupzb_17 .record-item:nth-child(2n) {
		background-color: var(--theme-main-bg-color)
	}

	._my-record_fupzb_17 .record-item .record-info {
		display: flex;
		align-items: center;
		color: var(--theme-text-color);
		font-size: .2rem;
		text-align: left
	}

	._my-record_fupzb_17 .record-item .record-info img {
		width: .44rem;
		height: .44rem;
		margin-right: .2rem
	}

	._my-record_fupzb_17 .record-item .record-info .record-desc {
		display: flex;
		align-items: center;
		margin-right: .1rem
	}

	._my-record_fupzb_17 .record-item .record-info .record-desc .time {
		width: 1.6rem
	}

	._my-record_fupzb_17 .record-item .amount {
		font-size: .22rem;
		color: var(--theme-primary-color)
	}

	._task_163pu_17 ._loading_163pu_17 {
		height: 5rem;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center
	}

	._task_163pu_17 ._task-desc_163pu_24 {
		color: var(--theme-text-color)
	}

	._task_163pu_17 ._lucky-integral_163pu_27 {
		color: var(--theme-primary-color)
	}

	._task_163pu_17 .task-list {
		padding-right: .2rem
	}

	._task_163pu_17 .task-list .ui-table__thead {
		background-color: var(--skin__bg_1)
	}

	._task_163pu_17 .task-list .ui-table__cell {
		min-height: .7rem;
		border-radius: .1rem
	}

	._task_163pu_17 .task-list .ui-table__cell:nth-child(2n) {
		background-color: var(--skin__bg_1)
	}

	._task_163pu_17 .task-list .ui-table__cell:nth-child(odd) {
		background-color: var(--theme-main-bg-color)
	}

	._turntable_1i0ek_17 {
		position: relative;
		width: 5rem;
		margin: .2rem auto
	}

	._turntable_1i0ek_17 .wheel {
		width: 100%;
		height: 5rem;
		background-size: 100% 100%;
		transition: transform 5s ease-in-out
	}

	._turntable_1i0ek_17 .whell-btn {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 1.683rem;
		width: 1.65rem;
		height: 1.825rem;
		margin: auto;
		background-position: 0 0;
		background-size: 100% 100%;
		display: flex;
		align-items: center;
		justify-content: center
	}

	._turntable_1i0ek_17 .whell-btn .draw {
		position: relative;
		width: 1.5rem;
		color: var(--theme-jackpot-num-bg-color-1);
		line-height: 1.2;
		text-align: center;
		font-size: .28rem;
		transform: translateY(.07rem)
	}

	._turntable_1i0ek_17 .whell-btn .draw:lang(hi) {
		margin-top: .12rem;
		font-size: .28rem
	}

	._turntable_1i0ek_17 .whell-btn .draw:lang(it) {
		margin-top: .08rem
	}

	._turntable_1i0ek_17 .whell-btn .draw:lang(it) p {
		transform: scale(.85)
	}

	._turntable_1i0ek_17 .whell-btn .draw:lang(ja) {
		margin-top: 0
	}

	._turntable_1i0ek_17 .whell-btn .draw:lang(tr) span {
		-webkit-box-orient: inherit;
		word-break: keep-all
	}

	._turntable_1i0ek_17 .whell-btn .draw:lang(ru)>span>span {
		display: block !important;
		transform: scale(.8)
	}

	._turntable_1i0ek_17 .wheel-pointer {
		position: absolute;
		top: -.05rem;
		left: 1.6rem;
		margin: auto;
		width: 1.758rem;
		height: 3.208rem;
		background-position: 0 0;
		background-size: 100% 100%
	}

	._turntable_1i0ek_17 .wheel-pointer>img {
		position: relative;
		left: .06rem;
		width: 1.667rem;
		height: 3.208rem;
	}

	._turntable_1i0ek_17._turntable-style8_1i0ek_89 ._whell-item_1i0ek_89,
	._turntable_1i0ek_17._turntable-style10_1i0ek_89 ._whell-item_1i0ek_89 {
		width: 1.1rem
	}

	._turntable_1i0ek_17._turntable-style12_1i0ek_92 ._whell-item_1i0ek_89 {
		width: .9rem
	}

	._whell-item_1i0ek_89 {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 10;
		width: 1.24rem;
		margin: auto;
		height: 4.458rem;
		color: var(--theme-jackpot-num-bg-color-1);
		font-size: .22rem;
		text-align: center
	}

	._whell-item_1i0ek_89 ._center_1i0ek_110 {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: .56rem
	}

	._whell-item_1i0ek_89 p {
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		vertical-align: middle;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		font-size: .22rem;
		line-height: .24rem;
		word-break: break-all
	}

	._whell-item_1i0ek_89 img {
		width: .665rem;
		height: .665rem
	}

	._winning_1i0ek_133 {
		animation: _winning_1i0ek_133 .2s 5 linear
	}

	@keyframes _winning_1i0ek_133 {
		0% {
			opacity: 0
		}

		to {
			opacity: 1
		}
	}

	._turntable-tabs_1yc53_62 {
		display: flex;
		justify-content: center
	}

	._turntable-tabs_1yc53_62>div {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		width: 2.1rem;
		height: .81rem;
		text-align: center;
		border: thin solid var(--theme-color-line);
		border-radius: .1rem
	}

	._turntable-tabs_1yc53_62>div:lang(hi) {
		box-shadow: 0 .05rem .18rem rgba(174, 184, 199, .2)
	}

	._turntable-tabs_1yc53_62>div:not(:nth-child(1)) {
		margin-left: .18rem
	}

	._turntable-tabs_1yc53_62>div p {
		width: 100%;
		color: var(--theme-text-color);
		font-size: .3rem;
		line-height: 1.2
	}

	._turntable-tabs_1yc53_62>div p:not(:lang(zh)):not(:lang(zh_hk)) {
		font-size: .22rem
	}

	._turntable-tabs_1yc53_62>div span {
		color: var(--theme-text-color);
		font-size: .24rem
	}

	._turntable-tabs_1yc53_62>div span:not(:lang(zh)):not(:lang(zh_hk)) {
		font-size: .18rem
	}

	._turntable-tabs_1yc53_62>div._active_1yc53_99 {
		border: none
	}

	._turntable-tabs_1yc53_62>div._active_1yc53_99 p,
	._turntable-tabs_1yc53_62>div._active_1yc53_99 span {
		color: var(--theme-jackpot-num-bg-color-1)
	}

	._turntable-tabs_1yc53_62>div._active_1yc53_99._silver_1yc53_106 {
		background-color: var(--theme-event-luck-wheel-silver)
	}

	._turntable-tabs_1yc53_62>div._active_1yc53_99._gold_1yc53_109 {
		background-color: var(--theme-event-luck-wheel-gold);
	}

	._turntable-tabs_1yc53_62>div._active_1yc53_99._diamond_1yc53_112 {
		background-color: var(--theme-event-luck-wheel-diamond)
	}
</style>